import { makeStyles, createStyles } from '@material-ui/core'

export const useContactStyles = makeStyles((theme) =>
  createStyles({
    avatarBlock: {
      position: 'relative'
    },

    avatar: {
      width: theme.spacing(20),
      height: theme.spacing(20),
      margin: theme.spacing(0, 'auto', 2)
    },

    crown: {
      position: 'absolute',
      left: '61%',
      top: 5,
      zIndex: 999
    },

    actions: {
      justifyContent: 'center'
    }
  })
)
